export enum SocialMedia {
  Facebook = "facebook",
  Instagram = "instagram",
  Youtube = "youtube",
}
